var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.251,
    height: 28.163,
    viewBox: "0 0 30.251 28.163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8723",
    "data-name": "\\uC0AC\\uAC01\\uD615 8723",
    width: 30.251,
    height: 28.163,
    fill: "#222"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_7571",
    "data-name": "\\uADF8\\uB8F9 7571",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12541",
    "data-name": "\\uD328\\uC2A4 12541",
    d: "M15.124,28.163a.907.907,0,0,1-.392-.091C8.024,24.715-.954,16.252.082,7.943.5,4.594,3.338.643,6.894.1A8.568,8.568,0,0,1,8.185,0a8,8,0,0,1,6.94,3.711A8.007,8.007,0,0,1,22.07,0a8.533,8.533,0,0,1,1.287.1c3.557.545,6.393,4.5,6.811,7.846,1.04,8.31-7.94,16.773-14.651,20.129a.9.9,0,0,1-.393.091M8.185,1.753a6.894,6.894,0,0,0-1.025.076c-2.731.42-5,3.673-5.337,6.33-.912,7.306,7.1,14.9,13.3,18.142,6.04-3.172,14.208-10.92,13.3-18.142-.331-2.657-2.6-5.91-5.335-6.33a6.885,6.885,0,0,0-1.023-.076A6.035,6.035,0,0,0,15.976,6.24a.877.877,0,0,1-1.7,0A6.035,6.035,0,0,0,8.185,1.753",
    transform: "translate(0 0)",
    fill: "#222"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon_heart.89bc1d53f2539f47542ebaeb27f2122b.svg";
export { ForwardRef as ReactComponent };